import { render, staticRenderFns } from "./ViewReportsTotalPostura.vue?vue&type=template&id=4ea5731a&scoped=true"
import script from "./ViewReportsTotalPostura.vue?vue&type=script&lang=js"
export * from "./ViewReportsTotalPostura.vue?vue&type=script&lang=js"
import style0 from "./ViewReportsTotalPostura.vue?vue&type=style&index=0&id=4ea5731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea5731a",
  null
  
)

export default component.exports